import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { currencyFormat } from '../../../../services/utils';

const useChangeCoveragePrice = () => {
  // re-format when the language changes (en-US, en-CA, fr-CA)
  const { i18n } = useTranslation();
  const store = useSelector(({ policies }) => ({ ...policies.changeCoverage }));
  const {
    quoteSelectedValues: {
      totalAnnual,
      totalMonthly,
    },
    rate: { isAnnual },
  } = store;

  const price = useMemo(() => {
    const value = isAnnual ? totalAnnual : totalMonthly;

    return currencyFormat({ value: value || 0 });
  }, [i18n.language, isAnnual, totalAnnual, totalMonthly]);

  return {
    isAnnual,
    price,
  };
};

export { useChangeCoveragePrice };
